<template>
  <div class="vote-detail" v-show="getList.length > 0">
    <img src="./images/header_bg.png" />
    <div class="vote-main">
      <div class="vote-rule">
        <div class="vote-title T1 S8">投票规则:</div>
        <div class="vote-word T1 S4">
          1.【投票规则】登录后，勾选候选人旁的方框，提交投票。
        </div>
        <div class="vote-word T1 S4 word-second">
          2.【有效认定】每个账户每日限投票3次。
        </div>
        <div class="vote-word T1 S4 word-third">
          参与投票用户即可获得平台福利，前5粉丝团可获额外福利。
        </div>
      </div>
      <VoteChoose :getList="getList"></VoteChoose>
      <div class="bottom-word S4 T5">最终解释权归第一财经</div>
    </div>
  </div>
</template>
<script>
import { Log, getClientInfo } from '@em/ym'
import config from '@/api/config'
import ym from '../../assets/js/ym'
import VoteChoose from '@/components/VoteChoose/VoteChoose'
import api from '@/api/api'
import { requestappInfo } from '@/api/appInfo'
export default {
  components: { VoteChoose },
  data() {
    return {
      getList: []
    }
  },
  mounted() {
    Log.pageView({
      targetView: 'yktApp:Activity:VoteDetail202201208'
    })
    requestappInfo()

    this.$onResume(() => {
      requestappInfo()
      getClientInfo(() => {})
    })
    ym.showMenuItems({
      menuItems: [
        {
          callback: () => {
            ym.showSharePop({
              title: '人气嘉宾票选',
              content: '有看投',
              url: `${config.h5Url}/vote-detail/`
            })
          },
          icon:
            'https://appstatic.emoney.cn/images/20210419/9365ccedef860827d27e3ac32c638071.png'
        }
      ]
    })

    api.vote
      .getPopularList({
        direction: 2,
        pageSize: 30
      })
      .then(res => {
        // console.log(res, 46364)
        if (res.result.code === 0) {
          this.getList = res.detail.list
        }
      })
  }
}
</script>
<style lang="scss" scoped>
.vote-detail {
  position: absolute;
  background: #046bcc;
  min-height: 100%;
  width: 100%;
  img {
    display: block;
    width: 100%;
  }
  .vote-main {
    padding: 0 24px;
    .vote-rule {
      opacity: 0.6;
      background: #ffffff;
      border-radius: 16px;
      padding: 42px 0 40px 40px;
      margin-bottom: 20px;
      .vote-title {
        line-height: 1;
        margin-bottom: 30px;
      }
      .vote-word {
        line-height: 1;
      }
      .word-second {
        margin: 22px 0;
      }
      .word-third {
        font-weight: 700;
      }
    }
    .bottom-word {
      opacity: 0.5;
      text-align: center;
      color: #fff;
      margin: 60px 0 24px;
    }
  }
}
</style>
